"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowControlsRule = void 0;
const game_rule_1 = require("./game-rule");
class ShowControlsRule extends game_rule_1.AbstractGameRule {
    applyRule(_commandHash, instant, context) {
        context.gameState.showGameControls(instant);
        return Promise.resolve(true);
    }
}
exports.ShowControlsRule = ShowControlsRule;
